/** Bylines for Insights articles (E-E-A-T). */
export const EDITORIAL_AUTHOR = {
  name: 'TradeRadar Editorial',
  jobTitle: 'Editorial & research',
};

export const INSIGHTS_PUBLISHED = '2026-03-01';
export const INSIGHTS_MODIFIED = '2026-03-29';
